import React from 'react';

import SmartLink from '../SmartLink';
import TypographySwitcher from '../TypographySwitcher';

import { ReactComponent as ArrowRight } from '../../assets/svg/arrow-forward.svg';

import styles from './index.module.scss';

export enum BackgroundColor {
  GRADIENT = 'gradient',
  RED = 'red',
  GREEN = 'green',
}

const BackgroundColorMap: Record<BackgroundColor, string> = {
  [BackgroundColor.GRADIENT]:
    'linear-gradient(90deg, rgba(85, 68, 148, 1) 0%, rgba(255, 97, 69, 1) 100%)',
  [BackgroundColor.RED]: '#c8585f',
  [BackgroundColor.GREEN]: '#7C9179',
};

export interface TextBannerSmallProps {
  title: string;
  text?: string;
  buttonUrl?: string;
  backgroundColor?: BackgroundColor;
}

const TextBannerSmall: React.FC<TextBannerSmallProps> = ({
  title,
  text,
  buttonUrl,
  backgroundColor = BackgroundColor.RED,
}) => {
  const backgroundColorStyle = BackgroundColorMap[backgroundColor];

  return (
    <>
      {buttonUrl ? (
        <SmartLink
          to={buttonUrl}
          className={`${styles.wrapper} ${styles.link}`}
          style={{ background: backgroundColorStyle }}
        >
          <div className={styles.titleAndIconWrapper}>
            <TypographySwitcher
              mobile='subtitle2'
              tablet='subtitle1'
              desktop='subtitle1'
            >
              {title}
            </TypographySwitcher>
            <ArrowRight className={styles.icon} />
          </div>
          {text && (
            <TypographySwitcher
              mobile='body2'
              tablet='body1'
              desktop='body1'
              className={styles.text}
            >
              {text}
            </TypographySwitcher>
          )}
        </SmartLink>
      ) : (
        <div
          className={styles.wrapper}
          style={{ background: backgroundColorStyle }}
        >
          <TypographySwitcher
            mobile='subtitle2'
            tablet='subtitle1'
            desktop='subtitle1'
          >
            {title}
          </TypographySwitcher>
          {text && (
            <TypographySwitcher
              mobile='body2'
              tablet='body1'
              desktop='body1'
              className={styles.text}
            >
              {text}
            </TypographySwitcher>
          )}
        </div>
      )}
    </>
  );
};

export default TextBannerSmall;
